import { useParams, useNavigate } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon, Person as PersonIcon } from '@mui/icons-material';
import PageLayout from '../components/ui/PageLayout';
import PersonDetailView from '../components/persons/PersonDetailView';

/**
 * Rota full-screen de detalhe da pessoa (/persons/:id).
 */
export default function PersonDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <PageLayout
      title="Detalhes da Pessoa"
      icon={<PersonIcon />}
    >
      <Box sx={{ mb: 2 }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/persons')}>
          Voltar para Pessoas
        </Button>
      </Box>
      <PersonDetailView personId={id} />
    </PageLayout>
  );
}
